exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__relative___2cdkB{position:relative}.index-module__relative___2cdkB .index-module__button___2PBV2{color:#1e265c;margin-bottom:0;background:#fff}.index-module__relative___2cdkB .index-module__button___2PBV2 div{display:inherit}.index-module__relative___2cdkB .index-module__button___2PBV2 svg{font-size:8px}.index-module__relative___2cdkB button{padding:1em;margin-bottom:.5em;width:150px;display:flex;justify-content:space-between;align-items:center;border-radius:5px;font-weight:700}.index-module__relative___2cdkB .index-module__options___1GCyu{position:absolute;left:50%;transform:translateX(-50%) translateY(.5em)}.index-module__relative___2cdkB .index-module__options___1GCyu .index-module__option___2AoPc{background:#169ab5;color:#fff}", ""]);

// exports
exports.locals = {
	"relative": "index-module__relative___2cdkB",
	"button": "index-module__button___2PBV2",
	"options": "index-module__options___1GCyu",
	"option": "index-module__option___2AoPc"
};